import React, { createContext } from 'react';

const QuotaModeGlobalContext = createContext({});
const QuotaModeLocalContext = createContext({});

export { QuotaModeLocalContext, QuotaModeGlobalContext };
